import { WebServiceLayoutMetadata } from "../../common-shared-module/model/dyn-form/form-metadata/layout/webservice-layout-metadata.model";
import { MetadataFactory } from "../../common-shared-module/model/dyn-form/form-metadata/metadata.factory";
import { Identified } from "./identified.model";
import { Layout } from "./layout.model";
import { RowLayout } from "./row-layout.model";



export class WebServiceLayout implements Layout, Identified {

    rows: RowLayout [] = []
    metadata: WebServiceLayoutMetadata
    icon: string = "public"

    constructor(meta?: WebServiceLayoutMetadata) {
        this.metadata = meta ? meta : MetadataFactory.createWebServiceLayout()
    }

    id(): string {
        return this.metadata.id
    }

    label(): string {
        return this.metadata.name
    }

    layout(): WebServiceLayoutMetadata {
        return this.metadata
    }

    removeRow(row: RowLayout) {
        this.rows = this.rows.filter(r => r != row)
    }

}